<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.min.js";

export default {
  name: "Banner.vue",

  props: {
    autoplay: { default: true },
    infinite: { default: true },
    dots: { default: false },
    autoplaySpeed: { default: 300000000000000 }
  },

  mounted() {
    this.$nextTick(function() {
      $(this.$el).slick({
        autoplay: this.autoplay,
        infinite: this.infinite,
        dots: this.dots,
        autoplaySpeed: this.autoplaySpeed
      });
    });
  }
};
</script>
